import usePermittedQuery from '_api/queries/usePermittedQuery';
import { Patient } from '_api/types';
import { ACCOUNT_TYPE } from '_constants';

export const GET_PATIENT_BY_ID_KEY = 'get-patient-by-id';

export const useGetPatientById = (id: number) => {
  return usePermittedQuery<Patient>(
    [
      ACCOUNT_TYPE.ADMIN,
      ACCOUNT_TYPE.ORG_ADMIN,
      ACCOUNT_TYPE.HOS_ADMIN,
      ACCOUNT_TYPE.THERAPIST,
    ],
    () => `/patient/${id}`,
    {},
    [GET_PATIENT_BY_ID_KEY],
    {
      enabled: typeof id === 'number' && id > 0,
      refetchOnWindowFocus: false,
    },
  );
};
